const styles = (theme) => ({
  formContainer: {
    paddingTop: "30px",
    paddingBottom: "30px",
    width: "60ch",
    maxWidth: "100%",
    margin: "auto",
    textAlign: "center",
  },
  textfield: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
      borderRadius: 12,
    },
    marginBottom: 32,
    width: "90%",
  },
  validateForm: {
    textDecoration: "none",
    color: "white",
    fontWeight: 600,
    marginTop: 20,
    marginBottom: 20,
    margin: theme.spacing(1),
    backgroundColor: theme.palette.orange.main,
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(255, 255, 255, 0.16)",
      color: "rgba(255, 255, 255, 0.7)",
    },
    "&:focus-visible": {
      outline: "2px solid #e8c635",
      outlineOffset: 2,
    },
  },
  connect: {
    color: "#A9B8E8",
    margin: theme.spacing(1),
    textDecoration: "none",
    "&:hover": {
      color: "#FFFFFF",
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: "2px solid #e8c635",
      outlineOffset: 2,
      borderRadius: 2,
    },
  },
  container: {
    padding: 30,
    borderRadius: 22,
    width: "100%",
    maxWidth: 500,
    height: "auto",
    minHeight: 450,
    boxSizing: "border-box",
    [theme.breakpoints.down("xs")]: {
      padding: 20,
      maxWidth: "calc(100vw - 32px)",
    },
  },
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
    paddingBottom: 24,
    paddingTop: 24,
  },
  card: {
    marginLeft: 32,
    height: 40,
    width: 40,
  },
  backgroundImg: {
    backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url('/background-login.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
  },
});

export default styles;
